// src/components/LevelUpOverlay.js – Enhanced cinematic
import React, { useEffect } from 'react';
import { useSound } from '../hooks/useSound';
import { useCinematic } from '../hooks/useCinematic';

export default function LevelUpOverlay({ level, onClose }) {
  const { playLevelUp } = useSound();
  const { screenShake, glowFlash, spawnSparks } = useCinematic();

  useEffect(() => {
    playLevelUp();
    screenShake(10, 22);
    glowFlash('rgba(255,215,0,0.18)', 600);
    // Spawn sparks from center
    const cx = window.innerWidth / 2, cy = window.innerHeight / 2;
    setTimeout(() => spawnSparks(cx, cy, 40, 'rgba(255,215,0,'), 100);
    setTimeout(() => spawnSparks(cx, cy, 30, 'rgba(0,245,255,'), 400);
    const t = setTimeout(onClose, 5500);
    return () => clearTimeout(t);
  }, [onClose, playLevelUp, screenShake, glowFlash, spawnSparks]);

  return (
    <div style={{
      position:'fixed', inset:0, background:'rgba(0,0,0,0.88)', zIndex:9990,
      display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column', gap:'12px',
    }}>
      <style>{`
        @keyframes lvlBounce{0%{transform:scale(0.35) rotate(-10deg);opacity:0}60%{transform:scale(1.1) rotate(2deg)}100%{transform:scale(1);opacity:1}}
        @keyframes starPop{0%{opacity:0;transform:scale(0)}60%{opacity:1;transform:scale(1.2)}100%{opacity:0.7;transform:scale(1)}}
        @keyframes lvlRing{0%{transform:scale(0.5);opacity:0.9}100%{transform:scale(2.5);opacity:0}}
      `}</style>

      {/* Ring effect */}
      <div style={{ position:'absolute', width:'200px', height:'200px', borderRadius:'50%',
                    border:'2px solid rgba(255,215,0,0.6)',
                    animation:'lvlRing 1s ease-out both', animationDelay:'0.1s' }} />
      <div style={{ position:'absolute', width:'200px', height:'200px', borderRadius:'50%',
                    border:'2px solid rgba(0,245,255,0.4)',
                    animation:'lvlRing 1s ease-out both', animationDelay:'0.35s' }} />

      {/* Star particles */}
      {[...Array(14)].map((_,i) => (
        <div key={i} style={{
          position:'absolute',
          width:'8px', height:'8px', borderRadius:'50%',
          background: i%3===0?'#ffd700':i%3===1?'#00f5ff':'#39ff14',
          top:`${12+Math.sin(i*0.9)*38}%`, left:`${8+i*6}%`,
          animation:`starPop ${0.5+Math.random()*0.8}s ease both`,
          animationDelay:`${i*0.07}s`,
          boxShadow:`0 0 10px currentColor`,
        }} />
      ))}

      <div style={{
        fontFamily:'var(--font-game)', fontSize:'58px', fontWeight:900,
        background:'linear-gradient(135deg,#ffd700,#00f5ff,#ffd700)',
        WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent',
        animation:'lvlBounce 0.65s cubic-bezier(0.16,1,0.3,1) both',
        textAlign:'center', filter:'drop-shadow(0 0 20px rgba(255,215,0,0.5))',
      }}>LEVEL UP!</div>

      <div style={{
        fontFamily:'var(--font-game)', fontSize:'20px', color:'rgba(255,255,255,0.75)',
        letterSpacing:'4px', animation:'lvlBounce 0.65s 0.12s cubic-bezier(0.16,1,0.3,1) both',
        textShadow:'0 0 16px rgba(0,245,255,0.4)',
      }}>
        LEVEL <span style={{ color:'#00f5ff' }}>{level}</span> REACHED
      </div>

      <button onClick={onClose} style={{
        marginTop:'22px', padding:'12px 38px',
        background:'rgba(255,215,0,0.12)', border:'1px solid rgba(255,215,0,0.45)',
        borderRadius:'6px', color:'#ffd700', cursor:'pointer',
        fontFamily:'var(--font-game)', fontWeight:700, letterSpacing:'2px', fontSize:'15px',
        animation:'lvlBounce 0.65s 0.28s both',
        boxShadow:'0 0 20px rgba(255,215,0,0.15)',
        transition:'all 0.2s',
      }}
        onMouseEnter={e => { e.currentTarget.style.background='rgba(255,215,0,0.2)'; e.currentTarget.style.boxShadow='0 0 28px rgba(255,215,0,0.3)'; }}
        onMouseLeave={e => { e.currentTarget.style.background='rgba(255,215,0,0.12)'; e.currentTarget.style.boxShadow='0 0 20px rgba(255,215,0,0.15)'; }}
      >CONTINUE ▶</button>
    </div>
  );
}
